import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import Loader from "../../../components/ui/Loader";
import CTOCategoryForm from "./CTOCategoryForm";

import { formatDateTimezon } from "../../../components/common-data/Converts";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { delete_cto_category } from "../../../data/ApiEndpoints";
import { showConfirmAlert } from "../../../components/components-react/ReactAlert";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const CTOCategories = ({ userInfoData, callFunction }) => {
  const dispatch = useDispatch();
  const { loading, ctoCategories } = useSelector((state) => state.api);
  const { loading: delLoading } = useSelector((state) => state.delApi);

  const [allCtoCategories, setAllCtoCategories] = useState([]);
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  // function getCTOCategories(filters = {}) {
  //   dispatch(
  //     fetchCtoCategoriesData({
  //       filters: filters,
  //       token: userInfoData?.token,
  //     })
  //   );
  // }

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_cto_category,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted Successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
    } else {
      toast.error("UID required!");
    }
  };

  // useEffect(() => {
  //   getCTOCategories();
  // }, []);

  useEffect(() => {
    if (ctoCategories?.status && !loading) {
      setAllCtoCategories(ctoCategories?.data || []);
    } else {
      setAllCtoCategories([]);
    }
  }, [ctoCategories, loading]);

  const tbColumns = [
    {
      dataField: "id",
      text: "S.NO.",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.id || "-"}</span>;
      },
    },
    {
      dataField: "category_name",
      text: "Category Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.category_name || "NA"}
            {/* {clickValues.isModOpen && clickValues.rowData?.id === row?.id ? <CTOCategoryForm /> : row?.category_name || "NA"} */}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background: row?.status === "active" ? "#0A701B" : "#D90000",
              color: "#fff",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "is_salary",
      text: "Fixed",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_salary ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          {clickValues.isModOpen && clickValues.rowData?.uid === row?.uid ? (
            <button
              type="button"
              variant="danger"
              className="actionBtn icon edit"
              onClick={() => setClickValues(iniClickValues)}
              style={{
                borderRadius: "8px",
                background: "#CB0201",
                color: "#fff",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                padding: "10px",
                textTransform: "capitalize",
              }}
            >
              Cancel Update
            </button>
          ) : (
            <>
              <button
                type="button"
                className="actionBtn icon edit"
                disabled={row?.is_salary}
                style={{
                  opacity: row?.is_salary ? "0.5" : "1",
                  cursor: row?.is_salary ? "not-allowed" : "pointer",
                }}
                onClick={
                  row?.is_salary
                    ? null
                    : () =>
                        setClickValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          rowData: row,
                          cardName: "edit",
                        }))
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
              </button>

              <button
                className="actionBtn icon delete"
                disabled={row?.is_salary}
                style={{
                  opacity: row?.is_salary ? "0.5" : "1",
                  cursor: row?.is_salary ? "not-allowed" : "pointer",
                }}
                onClick={
                  row?.is_salary
                    ? null
                    : () => {
                        const payload = {
                          uid: row?.uid,
                        };
                        handleDelete(payload);
                      }
                }
              >
                {delLoading ? (
                  <Loader />
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash3-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                  </svg>
                )}
              </button>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="flexCol">
      <CTOCategoryForm
        userInfoData={userInfoData}
        isEdit={clickValues.cardName === "edit"}
        rowData={clickValues.rowData}
        cancelUpdate={() => setClickValues(iniClickValues)}
        callFunction={callFunction}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allCtoCategories}
            tableColumns={tbColumns}
          />
        )}
      </div>
    </div>
  );
};

export default CTOCategories;
